import React, { Component } from "react";
import { Link } from "react-router-dom";

class HomeCard extends Component {
  render() {
    return (
      <Link
        onClick={this.props.onClickButton}
        to={this.props.to}
        className="th-link th-black py-2"
      >
        <div
          className="py-3 px-2"
          style={{
            // backgroundColor: "#DBF0F9",
            borderRadius: 16,
          }}
        >
          <div
            className="pt-5 pb-4"
            style={{
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundImage: `url(${this.props.iconImage})`,
            }}
          ></div>
          <h6 className="text-center th-12">{this.props.title}</h6>
        </div>
      </Link>
    );
  }
}
export default HomeCard;
